export default __webpack_public_path__ + "static/media/dep3_7.00eeaeaf.png";